import { render } from "./FiscalNotificationV2.vue?vue&type=template&id=27a1c5a7"
import script from "./FiscalNotificationV2.vue?vue&type=script&lang=js"
export * from "./FiscalNotificationV2.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__